import { render } from "./ModalCreateCustomView.vue?vue&type=template&id=a6006192"
import script from "./ModalCreateCustomView.vue?vue&type=script&lang=js"
export * from "./ModalCreateCustomView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__